

import { mapState } from "vuex";

export default {
    data() {
        return {

        }
    },
    computed: {
        ...mapState(["userModule"]),
    },
    watch: {
        "userModule.userName": {
            immediate: true,
            handler: function (n, o) {
                if (n) {
                    this.init();
                }
            },
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/role.js